import { useCallback } from 'react'
import { useApolloClient } from '@apollo/client'
import { useSignOut } from '@nhost/react'
import { clearLocalUserState } from '@/shared/lib/storageKeys'

/**
 * Abmelden und dabei alles vergessen, was am Konto hängt: die lokalen Schlüssel und
 * den Apollo-Cache. Ohne das Aufräumen sieht die nächste Anmeldung auf demselben
 * Gerät noch Daten der vorherigen - die Bezahlschranke liest `breastfeeding_paid`
 * als Startwert, bevor die Datenbank antwortet, und zeigt so lange bezahlte Inhalte.
 */
export function useAppSignOut() {
  const { signOut } = useSignOut()
  const client = useApolloClient()

  return useCallback(async () => {
    await signOut()
    clearLocalUserState()
    await client.clearStore()
  }, [signOut, client])
}
